import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Faq from '@/components/Relation/Faq';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';


const FaqPage:NextPage = () => {

  return (
    <>
      <NextSeo
        title='Green Parenting | FAQ'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/faq"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/faq-desktop.jpg",
            width: 1800,
            height: 422,
            alt: 'Green Parenting faq image',
          }]
        }}
      />
      <Header />
      <Faq />
      <Footer />
    </>
  )
}

export default FaqPage
